import { useEffect, useState } from "react";

/**
 * Returns the current time, re-rendering at the top of every minute so things
 * that depend on "now" (the current-time bar, past-event dimming) stay fresh
 * without a manual reload. Shared by CurrentTimeBar and the calendar grids.
 */
export function useNowMinute(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);
  return now;
}

export function useToday(): Date {
  const [today, setToday] = useState(() => new Date());
  useEffect(() => {
    let id: ReturnType<typeof setTimeout> | null = null;
    const schedule = () => {
      const now = new Date();
      const next = new Date(now);
      next.setHours(24, 0, 1, 0);
      id = setTimeout(() => {
        setToday(new Date());
        schedule();
      }, next.getTime() - now.getTime());
    };
    schedule();
    return () => { if (id) clearTimeout(id); };
  }, []);
  return today;
}
